<template>
  <Teleport to="body">
    <div v-if="visible" class="modal-overlay" @click.self="handleClose">
      <div class="modal-content">
        <div class="modal-header">
          <h3>{{ s__('Profile|Email Notifications') }}</h3>
          <button type="button" class="modal-close" @click="handleClose" aria-label="Close">
            <CloseIcon />
          </button>
        </div>

        <div class="modal-body">
          <div class="info-section">
            <p>
              {{
                s__(
                  'Profile|Email notifications send task and calendar updates to your confirmed email addresses.'
                )
              }}
            </p>

            <h4>{{ s__('Profile|How it works') }}</h4>
            <p>
              {{
                s__(
                  'Profile|When enabled, notifications are sent by email according to your event preferences.'
                )
              }}
            </p>

            <h4>{{ s__('Profile|Channel behavior') }}</h4>
            <p>
              {{
                s__(
                  'Profile|Silent hours apply only to Telegram DM notifications. Email notifications are sent regardless of silent hours.'
                )
              }}
            </p>
          </div>
        </div>

        <div class="modal-footer">
          <button type="button" class="btn-primary" @click="handleClose">
            {{ s__('Profile|Close') }}
          </button>
        </div>
      </div>
    </div>
  </Teleport>
</template>

<script setup>
import { computed } from 'vue'
import { Teleport } from 'vue'
import { s__ } from '@/locale'
import CloseIcon from '../common/icons/CloseIcon.vue'
import { useBodyScrollLock } from '@/composables/useBodyScrollLock'

const props = defineProps({
  visible: {
    type: Boolean,
    required: true,
  },
})

const emit = defineEmits(['close'])

useBodyScrollLock(computed(() => props.visible))

function handleClose() {
  emit('close')
}
</script>

<style scoped>
.info-section {
  line-height: 1.6;
}

.info-section h4 {
  margin: 20px 0 8px 0;
  font-size: 16px;
  font-weight: 600;
  color: #333;
}

.info-section h4:first-child {
  margin-top: 0;
}

.info-section p {
  margin: 0 0 16px 0;
  color: #666;
}
</style>
